// src/pages/HomePage.js
import React from 'react';
import PublicNavbar from '../components/PublicNavbar';
import Footer from '../components/Footer'; // Import the new Footer component
import './HomePage.css'; 

const HomePage = () => {
  return (
    <div className="home-page">
      <PublicNavbar />
      <header className="home-hero">
        <div className="home-hero-content">
          <h1>Connecting Homeless Communities to Valuable Resources</h1>
          <p className="mission-statement">
            In The Phoenix Metro Area
          </p>
        </div>
      </header>

      <main className="home-main-content">
        <section className="news-section">
          <h2>What does Refuge Ai do?</h2>
          
          <div className="info-card">
            <div className="info-card-image">
              <img src="https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Fhome_rf.jpg?alt=media&token=060ff4c0-dddb-49b7-a23e-9b0c58b49751" alt="Resource Finder" />
            </div>
            <div className="info-card-text">
              <h3>Resource Finder</h3>
              <p>A curated list of all of the free resources available in the area. Sorted by category, the user can tell the app what 
                they need and it will let them know how to access all of the free goods and services available. </p>
              <p className="news-link">
                <a href="https://refugeai.org/resources" target="_blank" rel="noopener noreferrer">
                  Click here to learn more.
                </a>
              </p>
            </div>
          </div>

          <div className="info-card">
            <div className="info-card-image">
              <img src="https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Fhome_jc.jpg?alt=media&token=cc90e8df-6452-450b-9a6f-ffd45481fb20" alt="Find Employment" />
            </div>
            <div className="info-card-text">
              <h3>Find Employment</h3>
              <p>After they have met their immediate needs, finding a new job is the most important next step for them. Our app includes 
                valuable tools that will ensure success finding and securing good employment.  </p>
              <p className="news-link">
                <a href="https://refugeai.org/about" target="_blank" rel="noopener noreferrer">
                  Click here to learn more.
                </a>
              </p>
            </div>
          </div>

          <div className="info-card">
            <div className="info-card-image">
              <img src="https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2FSlide05_002_V01.jpg?alt=media&token=d7a2e3eb-94ed-45ad-91c2-32f81b6c0144" />
            </div>
            <div className="info-card-text">
              <h3>Resume Builder</h3>
              <p>Most of us are not skilled at writing a resume. We have included a FREE Resume Builder into our app that is easy to use 
                and allows people to quickly write and send a resume to a potential job opportunity with a few clicks and a few minutes. 
                We have also included specific video instructions with direction and tips that we hope will help.  </p>
            </div>
          </div>

        </section>

        <section className="cta-section">
          <h2>Help Us Make a Difference</h2>
          <p>Your contribution helps us reach more individuals.</p>
          <p>We appreciate your support.</p>
          <a href="/donate" className="cta-button">Donate or Get Involved</a>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;